import fetch from '../utils/fetch'

export function setShopexErpSetting(query) {
  return fetch({
    url: '/third/shopexerp/setting',
    method: 'post',
    data: query
  })
}

export function getShopexErpSetting() {
  return fetch({
    url: '/third/shopexerp/setting',
    method: 'get'
  })
}

export function itemPriceUpdate(query) {
  return fetch({
    url: '/oms/goodsprice/update',
    method: 'put',
    data: query,
  })
}

export function getAllThirdsSetting() {
    return fetch({
        url: '/thirds/setting',
        method: 'get',
    })
}

export function setThirdsSetting(query) {
    return fetch({
        url: '/thirds/setting/edit',
        method: 'put',
        data:query,
    })
}

export function delThirdsSetting(query) {
    return fetch({
        url: '/thirds/setting/del',
        method: 'delete',
        data:query,
    })
}

export function getThirdsGiftLog(query) {
    return fetch({
        url: '/thirds/logs',
        method: 'post',
        data: query,
    })
}
export function getYgaList(query) {
    return fetch({
        url: 'libang/export',
        method: 'get',
        params: query
    })
}
export function getYgaListPost(query) {
    return fetch({
        url: 'libang/export',
        method: 'post',
        data: query,
    })
}
export function supreDataAdd(query) {
    return fetch({
        url: 'libang/supreDataAdd',
        method: 'get',
        params: query,
    })
}
export function getListYga(query) {
    return fetch({
        url: '/thirds/getYgalist',
        method: 'get',
        params: query,
    })
}



// WEBPACK FOOTER //
// ./src/api/third.js